/**
 * Client-side analytics loaders.
 *
 * IDs are hardcoded here (they're public-visible in the shipped JS bundle
 * anyway — same as if we'd put them in the HTML head). To keep preview clean,
 * we gate script loading by hostname: only production domains fire tracking.
 * Preview / localhost stay untouched even after `initAnalytics()` runs.
 */

const META_PIXEL_ID = "603092399805483";
const GA4_ID = "G-4WDVXSHK7D";

// Production hostnames. Add more if you point additional domains here.
const PRODUCTION_HOSTS = new Set([
  "sometodo.com",
  "www.sometodo.com",
  "maine-happenings.emergent.host",
]);

function isProductionHost() {
  if (typeof window === "undefined") return false;
  return PRODUCTION_HOSTS.has(window.location.hostname);
}

let initialized = false;

// --- Meta Pixel ---------------------------------------------------------
function loadMetaPixel(id) {
  // Standard Meta Pixel bootstrap (unminified for readability).
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
}

// --- GA4 ----------------------------------------------------------------
function loadGA4(id) {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", id);
}

export function initAnalytics() {
  if (initialized) return;
  initialized = true;
  if (!isProductionHost()) return; // preview / localhost — do nothing
  if (META_PIXEL_ID) loadMetaPixel(META_PIXEL_ID);
  if (GA4_ID) loadGA4(GA4_ID);
}

/**
 * Fire a PageView on client-side route change. Call from a component that
 * mounts once and watches location. Silently no-ops on non-production hosts.
 */
export function trackPageview(path) {
  if (!isProductionHost()) return;
  if (META_PIXEL_ID && window.fbq) {
    window.fbq("track", "PageView");
  }
  if (GA4_ID && window.gtag) {
    window.gtag("event", "page_view", { page_path: path });
  }
}
